/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const WhatsNewIntro = styled.p({
  whiteSpace: 'normal',
  marginTop: 0,
  paddingTop: '6px',
  color: token('color.text.subtle', colors.N200),
  font: token('font.body.UNSAFE_small'),
  marginBottom: token('space.100', '8px'),
});

export const Card = styled.div({
  backgroundColor: token('color.background.accent.gray.subtlest', colors.N20),
  padding: token('space.100', '8px'),
  margin: token('space.100', '8px'),
  borderRadius: token('border.radius', '3px'),
});

export const CardHeader = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const Date = styled.span({
  font: token('font.body.UNSAFE_small'),
  color: token('color.text.accent.gray', colors.N300),
});

export const CardInner = styled.div({
  padding: token('space.100', '8px'),
  backgroundColor: token('elevation.surface', colors.N0),
  borderRadius: token('border.radius', '3px'),
  marginTop: token('space.100', '8px'),
  boxShadow: `0 0 1px 0 ${token('color.blanket', colors.N50A)}`,
});

export const CardTitle = styled.span({
  font: token('font.body.large'),
  color: token('color.text', colors.N800),
});

export const LearnMoreLink = styled.a({
  color: token('color.link', colors.B400),
  font: token('font.body.UNSAFE_small'),
});
